import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Overview',
      href: '/en/Outdoor_Cameras/IN-9010_HD/',
    },
    {
      text: 'Specifications',
      href: '/en/Outdoor_Cameras/IN-9010_HD/Technical_Specifications/',
    },
    {
      text: 'Features',
      href: '/en/Outdoor_Cameras/IN-9010_HD/Product_Features/',
    },
    {
      text: 'Installation',
      href: '/en/Outdoor_Cameras/IN-9010_HD/Quick_Installation/',
    },
    {
      text: 'Lense Adjustment',
      href: '/en/Outdoor_Cameras/IN-9010_HD/Lense_Adjustment/',
    },
    {
      text: 'Usermanual',
      href: '/en/Outdoor_Cameras/IN-9010_HD/Usermanual/',
    },
    {
      text: '◄ Outdoor Cameras',
      href: '/en/Outdoor_Cameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-9010 Full HD Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}